/// <amd-module name="Release/Commands/AddReleasePipelineToDashboardCommandService" />
import * as React from "react";
import * as ReactDOM from "react-dom";

import { Spinner, SpinnerSize } from "VSSUI/Spinner";
import { Link } from "VSSUI/Link";

import { IVssService, VssService, Services } from "VSS/Platform/Context";
import { ReactRootComponent } from "VSS/Platform/Layout";
import { FormatComponent, FormatComponentProps } from "VSS/Platform/Components/Format";

import { LegacyComponent, ILegacyComponentProperties } from "VSS/Legacy/Legacy";
import { IMenuItem } from "VSSUI/Menu";
import { localeFormat } from "VSS/Core/Util/String";

import { getTFSPageData } from "Tfs/Platform/Page";

/*import { showAddToDashboard, PinArgs } from "TFSUI/Dashboards/AddToDashboard";*/
/*import { WidgetDataForPinning } from "TFSUI/Dashboards/AddToDashboardContracts";*/

import { IReleaseDefinitionPivotCommandContext } from "Release/Client/ExtensionContracts/IMenuCommandContracts";
import { publishClickEvent, publishSuccessEvent, publishFailedEvent } from "Release/Helpers/Telemetry";
import { createUrlForRoute } from "Release/Helpers/Link";
import { userHasMemberClaim } from "Release/Helpers/Permission";
import * as Resources from "Release/Commands/Resources";

export const addPipelineToDashboardCommand: (context: IReleaseDefinitionPivotCommandContext) => IMenuItem | undefined = (context: IReleaseDefinitionPivotCommandContext) => {
    if (userHasMemberClaim(context.pageContext)) {
        return {
            id: "add-release-pipeline-to-dashboard-command",
            text: Resources.AddToDashboard,
            iconProps: {
                iconName: "Add"
            },
            onActivate: () => {
                context.pageContext.getService<IAddReleasePipelineToDashboardCommandService>("IAddReleasePipelineToDashboardCommandService").addToDashboard(context);
            }
        };
    }
};

export interface IAddReleasePipelineToDashboardCommandService extends IVssService {
    addToDashboard(context: IReleaseDefinitionPivotCommandContext): void;
}

class AddReleasePipelineToDashboardCommandService extends VssService implements IAddReleasePipelineToDashboardCommandService {
    public addToDashboard(context: IReleaseDefinitionPivotCommandContext): void {
        let widgetData: any /*(WidgetDataForPinning*/ = {
            name: context.pipelineName,
            contributionId: "ms.vss-releaseManagement-web.release-definition-summary-widget",
            settings: JSON.stringify({ releaseDefinitionId: context.pipelineId }),
            settingsVersion: null,
            size: { columnSpan: 3, rowSpan: 2 }
        };

        const pageData = getTFSPageData(this.pageContext);
        const projectId = (pageData && pageData.project && pageData.project.id) || "";

        let addToDashboardProps: any /*PushToDashboardProps*/ = {
            projectId: projectId,
            widgetData: widgetData,
            actionCallback: (args: any /*PinArgs*/) => {
                if (args.response.outcome === 0) {
                    publishSuccessEvent(this.pageContext, addToDashboardFeature, context.telemetrySource);
                    const message = React.createElement(
                        FormatComponent,
                        { format: Resources.ReleasePipelineWidgetAddedSuccessfully } as FormatComponentProps,
                        React.createElement("b", {}, context.pipelineName),
                        React.createElement(Link,
                            {
                                href: createUrlForRoute(this.pageContext, "ms.vss-dashboards-web.dashboards-new-experience-route", {
                                    "teamName": args.commandArgs.groupId,
                                    "id": args.commandArgs.dashboardId
                                }),
                                rel: "noopener noreferrer",
                                style: { fontWeight: "bold" }
                            } as any,
                            args.commandArgs.dashboardName));
                    context.successCallback(message);
                }
                else {
                    publishFailedEvent(this.pageContext, addToDashboardFeature, context.telemetrySource);
                    context.errorCallback(localeFormat(Resources.ReleasePipelineWidgetAdditionFailed, context.pipelineName));
                }
            }
        };

        ReactDOM.unmountComponentAtNode(panelHostElement);

        publishClickEvent(this.pageContext, addToDashboardFeature, context.telemetrySource);
        ReactDOM.render(
            React.createElement(ReactRootComponent,
                {
                    pageContext: this.pageContext
                },
                React.createElement(LegacyComponent, {
                    modules: ["PipelineWorkflow/Scripts/Shared/LegacyLWP/DashboardPanelProxy"],
                    dependentContributionIds: ["ms.vss-releaseManagement-web.release-service-data"],
                    wrappedProps: addToDashboardProps,
                    wrappedType: "dashboard-panel-proxy",
                    loadingComponent: () => React.createElement(Spinner, { className: "flex flex-grow absolute-fill", size: SpinnerSize.large })
                } as ILegacyComponentProperties)),
            panelHostElement);
    }
}

const panelHostElement = document.createElement("div");
const addToDashboardFeature: string = "Command_AddToDashboard";

Services.add("IAddReleasePipelineToDashboardCommandService", { serviceFactory: AddReleasePipelineToDashboardCommandService });
